import styles from "./profileInnerLogs.module.scss";
// import iconincoming from "../../../styles/images/iconincoming.svg";
// import iconmissed from "../../../styles/images/iconmissed.svg";
// import iconoutgoing from "../../../styles/images/iconoutgoing.svg";
import { Modal } from "antd";
// import { URCheckBox } from "../../../maincomponents/checkbox";
// import { URButton } from '../../../maincomponents/button';
//import profilepicture from "../../../../styles/images/1a.png";
import profileemptypicuture from "../../../../styles/images/profile_empty_icon.svg";
//import profilestatusicon from "../../../../styles/images/profile-status-icon.svg";
// import { StatusTag } from '../../../maincomponents/statusTag';
//import { DownloadOutlined } from '@ant-design/icons';
import {  useState } from "react";
import React from "react";
import { StatusTag } from "../../../../shared/widgets/statusTag";
import { URButton } from "../../../../shared/widgets/button";

import { initialStateModel, LoginState, profileDetails } from "../../../../models/model";
import { useSelector } from "react-redux";

type profileInnerProps = {
  setProfileData:Function;
}

export default function ProfileInnerLogs({setProfileData}:profileInnerProps) {
  const loginDetails: LoginState = useSelector((state: initialStateModel) => state.loginReducer);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const showModal = () => {setIsModalVisible(true);};
  const handleCancel = () => {setIsModalVisible(false);};
  
  let { userdetails } = loginDetails;
  
  // const [openEditorstate, setopenEditorstate] = useState<profileInnerState>({profileData:{},
  //   userStatus: userdetails.user_status});
   
        
  const profileUserDetails:  profileDetails = useSelector((state: any) => state.profileReducer);
 
  const {profileData,userStatusData}=profileUserDetails;
  const openEditor = (value:any)=>{
 
    setProfileData(value);
  };
  
  const sendMail = async() => {
    try {
      var formattedBody = `
      Hi,
      You are Invite to join conference using given below number.

      Conference Invite Details :

      Conference Number: ${profileData.conference_number}
      Participation Code: ${profileData.partipation_code} 
      
      
      `;
      const participants: any = "";
      var emailto = encodeURI(participants);
      var subject = '';
      const generateURL= "mailto:" + emailto + "?subject="+subject + "&body=" +encodeURIComponent(formattedBody);
      window.open(generateURL, 'new');
    }
    catch (error) {
      console.log("error", error);
    }
  };



  return (
    <>
      <div className={styles.profileInnerTopSection}>
        <div className={styles.profileInnerTopHeader}>
          <div className={styles.profileInnerTopLeft}>
            <h3>Profile Details</h3>
            <div className={styles.profileTitle}>This is what others will see on your profile.</div>
          </div>
          <div className={styles.profileInnerTopRight}>
            <URButton className='urButton buttonBlue buttonSm' onClick={()=>openEditor(2)} name='Edit Profile'/>
            {/* <URButton className={styles.profileTitleButton} name='Edit Profile'/> */}
          </div>
        </div>
      </div>

      <div className={styles.profileReadScrollbar}>
        <div className={styles.profileBasicInformation}>
          <div className={styles.profileInformationTitle}>Basic Information</div>
          <div className={styles.profileInformationForm}>
            <div className={styles.profileInformationRow}>
              <div className={styles.profileFormLeft}>Profile Picture</div>
              <div className={styles.profileFormRight}><div className={styles.profileEmptyPicture}>
                <img className={styles.profilepicture}
                  src={userdetails?.profile_url?userdetails?.profile_url:profileemptypicuture} alt=""/></div> </div>
              {/*<div className={styles.profileFormRight}><div className={styles.profileEmptyPicture}>
              <img className={styles.profilepicture} src={profileemptypicuture} alt=""/></div></div>*/}
            </div>
            <div className={styles.profileInformationRow}>
              <div className={styles.profileFormLeft}>Profile Name</div>
              <div className={styles.profileFormRightName}>{profileData?.Firstname}</div>
            </div>
            <div className={styles.profileInformationRow}>
              <div className={styles.profileFormLeft}>Status</div>
              {userStatusData && <div className={styles.profileFormRight}>
                <div className={styles.meetingdropicon}><span className={userStatusData === "In a Meeting" ?
                    "icon_Calendar" : userStatusData === "Travelling" ?
                     "icon_Van" : userStatusData === "Sick" ?
                     "icon_sad" : userStatusData === "On Vacation" ?
                     "icon_Natural" : "icon_Home"}>
                  </span>
                <StatusTag className='statusTag bgGrey' name={userStatusData &&
                  userStatusData}/>
                  </div>
              </div>}
            </div>
            <div className={styles.profileInformationRow}>
              <div className={styles.profileFormLeft}>Time Zone</div>
              <div className={styles.profileFormRight}>{profileData?.Time_zone === "2" ?
                "(GMT+05:30) India Standard Time" : profileData?.Time_zone}</div>
            </div>
            <div className={styles.profileInformationRow}>
              <div className={styles.profileFormLeft}>Native Language</div>
              <div className={styles.profileFormRight}>{ profileData?.User_Language}</div>
            </div>
          </div>
          
          <div className={styles.profileInformationTitle}>Personal Information</div>
          <div className={styles.profileInformationForm}>
            <div className={styles.profileInformationRow}>
              <div className={styles.profileFormLeft}>Full Name</div>
              {profileData?.Firstname && profileData?.Surname &&
              <div className={styles.profileFormRight}>
                {`${profileData?.Firstname} ${profileData?.Surname}`}</div>}
            </div>
            {/* <div className={styles.profileInformationRow}>
              <div className={styles.profileFormLeft}>Designation</div>
              <div className={styles.profileFormRight}>{openEditorstate.profileData?.Role_Name}</div>
            </div> */}
             <div className={styles.profileInformationRow}>
              <div className={styles.profileFormLeft}>Designation</div>
              <div className={styles.profileFormRight}>{profileData?.position ?? ""}</div>
            </div>
            <div className={styles.profileInformationRow}>
              <div className={styles.profileFormLeft}>Department</div>
              <div className={styles.profileFormRight}>{profileData?.Department?
                profileData?.Department:"--"}</div>
            </div>
            <div className={styles.profileInformationRow}>
              <div className={styles.profileFormLeft}>Employee ID</div>
              <div className={styles.profileFormRight}>{profileData?.emp_id}</div>
            </div>
            <div className={styles.profileInformationRow}>
              <div className={styles.profileFormLeft}>Email Address</div>
              <div className={`${styles.emailid} ${styles.profileFormRight}`}>{profileData?.Email}</div>
            </div>
            <div className={styles.profileInformationRow}>
              <div className={styles.profileFormLeft}>Extension</div>
              <div className={styles.profileFormRight}>{profileData?.Extension_Number}</div>
            </div>
           { profileData?.Direct_Number &&  <div className={styles.profileInformationRow}>
              <div className={styles.profileFormLeft}>Worktual</div>
              <div className={styles.profileFormRight}>{profileData?.Direct_Number}</div>
            </div> }
          {  profileData?.switch_board_no && <div className={styles.profileInformationRow}>
              <div className={styles.profileFormLeft}>Company</div>
              <div className={styles.profileFormRight}>{ profileData.switch_board_no}</div>
            </div>}
           {profileData?.Mobileno && <div className={styles.profileInformationRow}>
              <div className={styles.profileFormLeft}>Mobile</div>
              <div className={styles.profileFormRight}>{profileData.Mobileno}</div>
            </div>}
           { profileData?.International_number && <div className={styles.profileInformationRow}>
              <div className={styles.profileFormLeft}>International (USA)</div>
              <div className={styles.profileFormRight}>{profileData.International_number}</div>
            </div>}
           { profileData?.conference_number && <div className={styles.profileInformationRow}>
              <div className={styles.profileFormLeft}>Conference Number</div>
              <div className={styles.profileFormRight}>{ profileData.conference_number}</div>
            </div>}
          { profileData?.host_code && <div className={styles.profileInformationRow}>
              <div className={styles.profileFormLeft}>Host Code</div>
              <div className={styles.profileFormRight}>{ profileData.host_code}</div>
            </div>}
         {  profileData?.partipation_code &&  <div className={styles.profileInformationRow}>
              <div className={styles.profileFormLeft}>Participation Code</div>
              <div className={styles.profileFormRight}>{ profileData.partipation_code }</div>
            </div>}
          </div>
          <div className={styles.sendmailright}>
            <URButton className='urButton buttonBlue buttonSm' name='Send Email Invite' onClick={showModal}/>
          </div>

          <Modal title="Conference Invite details" 
        centered 
        visible={isModalVisible} 
        onOk={sendMail}
        onCancel={handleCancel}
        cancelText="Cancel"
        okText="Send Invite"
        cancelButtonProps={{ className: 'urButton buttonWhite' }}
        okButtonProps={{ className: 'urButton buttonBlue' }} className="customPopup confreninmodal">
         <p className='yourconftxt'>Your conference bridge details. You can dial in your conference number and enter your host code with # at the end.Share the participant code with your participants.</p>
            
            <div className='readtextCon'>   
              <div className='confrenceinvite'>
                <span>Company Conference Number:</span>
              </div> 
              <div className='confrenceright'>
                <label>{ profileData.conference_number}</label>              
              </div> 
            </div>
            <div className='readtextCon'>   
              <div className='confrenceinvite'>
                <span>Participation Code:</span>
              </div> 
              <div className='confrenceright'>
                <label>{ profileData.partipation_code}</label>              
              </div> 
         </div>
          </Modal>
        </div>
      </div>
      

    </>
    
  );
};
